import { DEFAULT_ORDER_TYPE } from '../constants/Constants';

const toGroupUri = (group) => {
  if (typeof group === 'string') {
    return group.trim();
  }

  if (group && typeof group === 'object') {
    if (typeof group.uri === 'string' && group.uri.trim()) {
      return group.uri.trim();
    }
    if (group.id) {
      return `/groups/${group.id}`;
    }
  }

  return '';
};

export const buildFormValues = ({ addressee, user, group, lastOrder }) => {
  const groupUri = toGroupUri(group);

  const formValues = {
    email: user?.email,
    contact_name: `${user.first_name} ${user.last_name}`,
    contact_first_name: user.first_name,
    contact_last_name: user.last_name,
    lrc3200_quantity: lastOrder?.lrc3200_quantity || 0,
    lrc5000_quantity: lastOrder?.lrc5000_quantity || 0,
    order_types: [DEFAULT_ORDER_TYPE],
    order: {
      group: groupUri,
      type: DEFAULT_ORDER_TYPE.id,
      comments: lastOrder?.comments,
      phone: lastOrder?.callback_phone_number,
      shipping_address: {
        addressee: addressee?.addressee,
        city: group?.city,
        country: group?.country,
        post_office_box_number: addressee?.post_office_box_number,
        postal_code: addressee?.postal_code,
        state: group?.state,
        street_address: addressee?.street_address,
        uri: addressee?.uri,
      },
    },
  };

  return formValues;
};

export const buildAddressAndRemoteBodies = (form) => {
  const groupUri = toGroupUri(form?.order?.group) || toGroupUri(form?.order?.group_uri);

  const addressBody = {
    addressee: form.order.shipping_address.addressee,
    country: form.order.shipping_address.country,
    group: groupUri,
    locality: form.order.shipping_address.city,
    post_office_box_number: form.order.shipping_address.post_office_box_number, // TODO - check where to obtain this value
    postal_code: form.order.shipping_address.postal_code,
    region: form.order.shipping_address.state,
    street_address: form.order.shipping_address.street_address,
  };

  const remoteBody = {
    callback_phone_number: form.order.phone,
    contact_first_name: form.contact_first_name,
    contact_last_name: form.contact_last_name,
    group: groupUri,
    lrc3200_quantity: form.lrc3200_quantity || 0,
    lrc5000_quantity: form.lrc5000_quantity || 0,
  };

  return { addressBody, remoteBody };
};

export const buildShippingAddressBody = ({ addressee, form }) => {
  const shippingAddress = {
    addressee: addressee?.addressee || '',
    city: form.order.shipping_address.city,
    country: form.order.shipping_address.country,
    post_office_box_number: addressee?.post_office_box_number || '',
    postal_code: addressee?.postal_code || '',
    state: form.order.shipping_address.state,
    street_address: addressee?.street_address || '',
    uri: addressee?.uri || null,
  };
  return shippingAddress;
};
